import { render, staticRenderFns } from "./ProInfo1Edit.vue?vue&type=template&id=19a8aaec&scoped=true"
import script from "./ProInfo1Edit.vue?vue&type=script&lang=js"
export * from "./ProInfo1Edit.vue?vue&type=script&lang=js"
import style0 from "./ProInfo1Edit.vue?vue&type=style&index=0&id=19a8aaec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a8aaec",
  null
  
)

export default component.exports